import * as React from 'react';
import { Image, PageHeader } from 'react-bootstrap';
import { observer } from 'mobx-react';

import { inject } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';

@observer
export default class HeadferPublic extends React.Component<{}, {}> {

  @inject(UiStore) uiStore: UiStore;

  render() {

    return (
      <header className="header" role="banner">
        <div className="border-bottom">
          <div className="container">
            <PageHeader>
              <a href="https://www.diq-zert.de"><Image src={require('../../assets/images/logo_diqz.png')} className="header-logo-extern" /></a>
            </PageHeader>
          </div>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/public/HeaderPublic.tsx